module.exports = __webpack_public_path__ + "img/sabt_dar_shobe.f6ac7108.png";